import styled from 'styled-components';

export const ShippingOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0;
`;

export const ShippingCard = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 2px solid ${props => (props.selected ? 'var(--primary)' : '#e0e0e0')};
  border-radius: 8px;
  background-color: ${props => (props.selected ? '#f8f9ff' : '#ffffff')};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--primary);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const ShippingInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ShippingTitle = styled.h3`
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const ShippingDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
`;

export const ShippingPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 16px;
`;

export const PriceValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: var(--primary);
`;

export const DeliveryTime = styled.span`
  font-size: 12px;
  color: #888;
  margin-top: 2px;
`;

export const RadioButton = styled.div<{ selected: boolean }>`
  width: 20px;
  height: 20px;
  border: 2px solid ${props => (props.selected ? 'var(--primary)' : '#ccc')};
  border-radius: 50%;
  margin-right: 12px;
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--primary);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: ${props => (props.selected ? 1 : 0)};
    transition: opacity 0.2s ease;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
`;

export const ErrorContainer = styled.div`
  padding: 16px;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  color: #c33;
  text-align: center;
`;

export const AddressInfo = styled.div`
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eee;
`;

export const AddressText = styled.p`
  margin: 0;
  font-size: 12px;
  color: #888;
  line-height: 1.3;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;
